import Vue from 'vue'
import Router from 'vue-router'
import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from '@/store'
// import accessMiddleware from './middleware/access'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
Vue.router = router

sync(store, router)
// accessMiddleware(router)

export default router
